// // // // regionApi.js

// // // const API_BASE = "https://assocham.org/api";

// // // // 🔑 Map frontend slugs to database slugs
// // // const SLUG_OVERRIDES = {
// // //   "tamil-nadu": "tamil-nadu-state-development-council",
// // //   // Add other states if their frontend slug differs from the DB slug
// // //   // "andhra-pradesh": "andhra-pradesh-state-development-council",
// // //   // "karnataka": "karnataka-state-development-council",
// // // };

// // // export async function getRegionBySlug(slug) {
// // //   if (!slug) return null;
// // //   const dbSlug = SLUG_OVERRIDES[slug] || slug;
// // //   console.log('[getRegionBySlug] frontend slug:', slug, '→ DB slug:', dbSlug);

// // //   try {
// // //     const res = await fetch(`${API_BASE}/get_region.php?slug=${encodeURIComponent(dbSlug)}`);
// // //     const json = await res.json();
// // //     if (!json.success) return null;
// // //     return json.data;
// // //   } catch (err) {
// // //     console.error("getRegionBySlug error:", err);
// // //     return null;
// // //   }
// // // }

// // // export async function getCouncilLeadership(slug) {
// // //   if (!slug) return [];
// // //   const dbSlug = SLUG_OVERRIDES[slug] || slug;
// // //   try {
// // //     const res = await fetch(`${API_BASE}/getCouncilLeadership-state.php?slug=${encodeURIComponent(dbSlug)}`);
// // //     const json = await res.json();
// // //     if (json.success) {
// // //       return json.data;
// // //     }
// // //     return [];
// // //   } catch (error) {
// // //     console.error('Failed to fetch council leadership:', error);
// // //     return [];
// // //   }
// // // }

// // // export async function fetchRegionEvents(slug) {
// // //   if (!slug) return [];
// // //   const dbSlug = SLUG_OVERRIDES[slug] || slug;
// // //   console.log('[fetchRegionEvents] frontend slug:', slug, '→ DB slug:', dbSlug);

// // //   try {
// // //     const res = await fetch(`${API_BASE}/get_region_events.php?slug=${encodeURIComponent(dbSlug)}`);
// // //     const json = await res.json();
// // //     if (!json.success) {
// // //       console.warn('fetchRegionEvents API error:', json.message);
// // //       return [];
// // //     }
// // //     console.log('fetchRegionEvents data:', json.data);
// // //     return json.data || [];
// // //   } catch (err) {
// // //     console.error("fetchRegionEvents error:", err);
// // //     return [];
// // //   }
// // // }



// // // export async function fetchRegionPublications(slug) {
// // //   if (!slug) return [];
// // //   const dbSlug = SLUG_OVERRIDES[slug] || slug;
// // //   try {
// // //     const res = await fetch(`${API_BASE}/get_region_publications.php?slug=${encodeURIComponent(dbSlug)}`);
// // //     const json = await res.json();
// // //     if (!json.success) {
// // //       console.warn('fetchRegionPublications API error:', json.message);
// // //       return [];
// // //     }
// // //     return json.data || [];
// // //   } catch (err) {
// // //     console.error("fetchRegionPublications error:", err);
// // //     return [];
// // //   }
// // // }


// // // // Add these functions to regionApi.js

// // // export async function fetchRegionPressReleases(slug) {
// // //   if (!slug) return [];
// // //   const dbSlug = getDbSlug(slug);
// // //   try {
// // //     const res = await fetch(`${API_BASE}/get_region_press_releases.php?slug=${encodeURIComponent(dbSlug)}`);
// // //     const json = await res.json();
// // //     if (!json.success) {
// // //       console.warn('fetchRegionPressReleases API error:', json.message);
// // //       return [];
// // //     }
// // //     return json.data || [];
// // //   } catch (err) {
// // //     console.error("fetchRegionPressReleases error:", err);
// // //     return [];
// // //   }
// // // }

// // // export async function fetchRegionPressCoverage(slug) {
// // //   if (!slug) return [];
// // //   const dbSlug = getDbSlug(slug);
// // //   try {
// // //     const res = await fetch(`${API_BASE}/get_region_press_coverage.php?slug=${encodeURIComponent(dbSlug)}`);
// // //     const json = await res.json();
// // //     if (!json.success) {
// // //       console.warn('fetchRegionPressCoverage API error:', json.message);
// // //       return [];
// // //     }
// // //     return json.data || [];
// // //   } catch (err) {
// // //     console.error("fetchRegionPressCoverage error:", err);
// // //     return [];
// // //   }
// // // }




// // // new new code 






// // // regionApi.js

// // const API_BASE = "https://assocham.org/assocham_backend/api";

// // // Explicit overrides for states where the frontend slug differs from the DB slug
// // const SLUG_OVERRIDES = {
// //   // "tamil-nadu": "tamil-nadu-state-development-council",
// //   // "telangana": "telangana-state-development-council",
// //   // Add others if they don't follow the pattern
// //   // "andhra-pradesh": "andhra-pradesh-state-development-council",
// //   // "karnataka": "karnataka-state-development-council",
// // };

// // /**
// //  * Convert a frontend slug (e.g., "tamil-nadu") to the database slug.
// //  * If there's no explicit override, we append "-state-development-council"
// //  * unless the slug already ends with that string.
// //  */
// // function getDbSlug(frontendSlug) {
// //   if (!frontendSlug) return frontendSlug;
// //   const trimmed = frontendSlug.trim();
// //   const override = SLUG_OVERRIDES[trimmed];
// //   if (override) return override;
// //   // If it doesn't already end with "-state-development-council", add it.
// //   if (!trimmed.endsWith('-state-development-council')) {
// //     return `${trimmed}-state-development-council`;
// //   }
// //   return trimmed;
// // }

// // export async function getRegionBySlug(slug) {
// //   if (!slug) return null;
// //   const dbSlug = getDbSlug(slug);
// //   console.log('[getRegionBySlug] frontend slug:', slug, '→ DB slug:', dbSlug);

// //   try {
// //     const res = await fetch(`${API_BASE}/get_region.php?slug=${encodeURIComponent(dbSlug)}`);
// //     const json = await res.json();
// //     if (!json.success) return null;
// //     return json.data;
// //   } catch (err) {
// //     console.error("getRegionBySlug error:", err);
// //     return null;
// //   }
// // }

// // export async function getCouncilLeadership(slug) {
// //   if (!slug) return [];
// //   const dbSlug = getDbSlug(slug);
// //   try {
// //     const res = await fetch(`${API_BASE}/getCouncilLeadership-state.php?slug=${encodeURIComponent(dbSlug)}`);
// //     const json = await res.json();
// //     if (json.success) {
// //       return json.data;
// //     }
// //     return [];
// //   } catch (error) {
// //     console.error('Failed to fetch council leadership:', error);
// //     return [];
// //   }
// // }

// // export async function fetchRegionEvents(slug) {
// //   if (!slug) return [];
// //   const dbSlug = getDbSlug(slug);
// //   console.log('[fetchRegionEvents] frontend slug:', slug, '→ DB slug:', dbSlug);

// //   try {
// //     const res = await fetch(`${API_BASE}/get_region_events.php?slug=${encodeURIComponent(dbSlug)}`);
// //     const json = await res.json();
// //     if (!json.success) {
// //       console.warn('fetchRegionEvents API error:', json.message);
// //       return [];
// //     }
// //     return json.data || [];
// //   } catch (err) {
// //     console.error("fetchRegionEvents error:", err);
// //     return [];
// //   }
// // }

// // export async function fetchRegionPublications(slug) {
// //   if (!slug) return [];
// //   const dbSlug = getDbSlug(slug);
// //   try {
// //     const res = await fetch(`${API_BASE}/get_region_publications.php?slug=${encodeURIComponent(dbSlug)}`);
// //     const json = await res.json();
// //     if (!json.success) {
// //       console.warn('fetchRegionPublications API error:', json.message);
// //       return [];
// //     }
// //     return json.data || [];
// //   } catch (err) {
// //     console.error("fetchRegionPublications error:", err);
// //     return [];
// //   }
// // }

// // export async function fetchRegionPressReleases(slug) {
// //   if (!slug) return [];
// //   const dbSlug = getDbSlug(slug);
// //   try {
// //     const res = await fetch(`${API_BASE}/get_region_press_releases.php?slug=${encodeURIComponent(dbSlug)}`);
// //     const json = await res.json();
// //     if (!json.success) {
// //       console.warn('fetchRegionPressReleases API error:', json.message);
// //       return [];
// //     }
// //     return json.data || [];
// //   } catch (err) {
// //     console.error("fetchRegionPressReleases error:", err);
// //     return [];
// //   }
// // }

// // export async function fetchRegionPressCoverage(slug) {
// //   if (!slug) return [];
// //   const dbSlug = getDbSlug(slug);
// //   try {
// //     const res = await fetch(`${API_BASE}/get_region_press_coverage.php?slug=${encodeURIComponent(dbSlug)}`);
// //     const json = await res.json();
// //     if (!json.success) {
// //       console.warn('fetchRegionPressCoverage API error:', json.message);
// //       return [];
// //     }
// //     return json.data || [];
// //   } catch (err) {
// //     console.error("fetchRegionPressCoverage error:", err);
// //     return [];
// //   }
// // }




// // new new code 




// // regionApi.js

// const API_BASE = "https://assocham.org/assocham_backend/api";

// // Explicit overrides for states where the frontend slug differs from the DB slug
// const SLUG_OVERRIDES = {
//   "maharashtra": "maharashtra-state-council",
//   // "tamil-nadu": "tamil-nadu-state-development-council",
//   // "telangana": "telangana-state-development-council",
//   // Add others if they don't follow the pattern
//   // "andhra-pradesh": "andhra-pradesh-state-development-council",
//   // "karnataka": "karnataka-state-development-council",
// };

// /**
//  * Convert a frontend slug (e.g., "tamil-nadu") to the database slug.
//  * If there's no explicit override, we append "-state-development-council"
//  * unless the slug already ends with that string.
//  */
// function getDbSlug(frontendSlug) {
//   if (!frontendSlug) return frontendSlug;
//   const trimmed = frontendSlug.trim();
//   const override = SLUG_OVERRIDES[trimmed];
//   if (override) return override;
//   // If it doesn't already end with "-state-development-council", add it.
//   if (!trimmed.endsWith('-state-development-council')) {
//     return `${trimmed}-state-development-council`;
//   }
//   return trimmed;
// }

// export async function getRegionBySlug(slug) {
//   if (!slug) return null;
//   const dbSlug = getDbSlug(slug);
//   console.log('[getRegionBySlug] frontend slug:', slug, '→ DB slug:', dbSlug);

//   try {
//     const res = await fetch(`${API_BASE}/get_region.php?slug=${encodeURIComponent(dbSlug)}`);
//     const json = await res.json();
//     if (!json.success) return null;
//     return json.data;
//   } catch (err) {
//     console.error("getRegionBySlug error:", err);
//     return null;
//   }
// }

// export async function getCouncilLeadership(slug) {
//   if (!slug) return [];
//   const dbSlug = getDbSlug(slug);
//   try {
//     const res = await fetch(`${API_BASE}/getCouncilLeadership-state.php?slug=${encodeURIComponent(dbSlug)}`);
//     const json = await res.json();
//     if (json.success) {
//       return json.data;
//     }
//     return [];
//   } catch (error) {
//     console.error('Failed to fetch council leadership:', error);
//     return [];
//   }
// }

// export async function fetchRegionEvents(slug) {
//   if (!slug) return [];
//   const dbSlug = getDbSlug(slug);
//   console.log('[fetchRegionEvents] frontend slug:', slug, '→ DB slug:', dbSlug);

//   try {
//     const res = await fetch(`${API_BASE}/get_region_events.php?slug=${encodeURIComponent(dbSlug)}`);
//     const json = await res.json();
//     if (!json.success) {
//       console.warn('fetchRegionEvents API error:', json.message);
//       return [];
//     }
//     return json.data || [];
//   } catch (err) {
//     console.error("fetchRegionEvents error:", err);
//     return [];
//   }
// }

// export async function fetchRegionPublications(slug) {
//   if (!slug) return [];
//   const dbSlug = getDbSlug(slug);
//   try {
//     const res = await fetch(`${API_BASE}/get_region_publications.php?slug=${encodeURIComponent(dbSlug)}`);
//     const json = await res.json();
//     if (!json.success) {
//       console.warn('fetchRegionPublications API error:', json.message);
//       return [];
//     }
//     return json.data || [];
//   } catch (err) {
//     console.error("fetchRegionPublications error:", err);
//     return [];
//   }
// }

// export async function fetchRegionPressReleases(slug) {
//   if (!slug) return [];
//   const dbSlug = getDbSlug(slug);
//   try {
//     const res = await fetch(`${API_BASE}/get_region_press_releases.php?slug=${encodeURIComponent(dbSlug)}`);
//     const json = await res.json();
//     if (!json.success) {
//       console.warn('fetchRegionPressReleases API error:', json.message);
//       return [];
//     }
//     return json.data || [];
//   } catch (err) {
//     console.error("fetchRegionPressReleases error:", err);
//     return [];
//   }
// }

// export async function fetchRegionPressCoverage(slug) {
//   if (!slug) return [];
//   const dbSlug = getDbSlug(slug);
//   try {
//     const res = await fetch(`${API_BASE}/get_region_press_coverage.php?slug=${encodeURIComponent(dbSlug)}`);
//     const json = await res.json();
//     if (!json.success) {
//       console.warn('fetchRegionPressCoverage API error:', json.message);
//       return [];
//     }
//     return json.data || [];
//   } catch (err) {
//     console.error("fetchRegionPressCoverage error:", err);
//     return [];
//   }
// }






// new code 





// regionApi.js

const API_BASE = "https://assocham.org/assocham_backend/api";

// Explicit overrides for states where the frontend slug differs from the DB slug
const SLUG_OVERRIDES = {
  "maharashtra": "maharashtra-state-council",
  // "tamil-nadu": "tamil-nadu-state-development-council",
  // "telangana": "telangana-state-development-council",
  // "andhra-pradesh": "andhra-pradesh-state-development-council",
  // "karnataka": "karnataka-state-development-council",
};

/**
 * Convert a frontend slug (e.g., "tamil-nadu") to the database slug.
 */
function getDbSlug(frontendSlug) {
  if (!frontendSlug) return frontendSlug;
  const trimmed = frontendSlug.trim();
  const override = SLUG_OVERRIDES[trimmed];
  if (override) return override;
  if (!trimmed.endsWith('-state-development-council')) {
    return `${trimmed}-state-development-council`;
  }
  return trimmed;
}

/* ------------------------------------------------------------------
 * CLEANUP HELPERS
 * Purane / double-escaped data ko saaf karne ke liye.
 * Example:
 *   country\'s      -> country's
 *   <\/p>           -> </p>
 *   \\\\            -> \\
 * ------------------------------------------------------------------ */

/**
 * Clean a single string value coming from the API.
 * - Convert \'  -> '
 * - Convert \"  -> "
 * - Convert \/  -> /
 * - Collapse \\\\ -> \\
 */
function cleanString(value) {
  if (typeof value !== 'string') return value;

  let out = value;

  // Fix over-escaped slashes (\/ and \\/)
  out = out.replace(/\\+\//g, '/');

  // Fix backslash-escaped single quotes: \' -> '
  // Handles multiple backslashes: \\' -> '
  out = out.replace(/\\+'/g, "'");

  // Fix backslash-escaped double quotes: \" -> "
  out = out.replace(/\\+"/g, '"');

  // Collapse duplicate backslashes: \\\\ -> \\
  out = out.replace(/\\\\{2,}/g, '\\\\');

  return out;
}

/**
 * Recursively clean all string fields in an object / array.
 */
function cleanDeep(data) {
  if (data == null) return data;

  if (typeof data === 'string') return cleanString(data);

  if (Array.isArray(data)) return data.map(cleanDeep);

  if (typeof data === 'object') {
    const out = {};
    for (const key of Object.keys(data)) {
      out[key] = cleanDeep(data[key]);
    }
    return out;
  }

  return data;
}

/* ------------------------------------------------------------------
 * API FUNCTIONS
 * ------------------------------------------------------------------ */

export async function getRegionBySlug(slug) {
  if (!slug) return null;
  const dbSlug = getDbSlug(slug);
  console.log('[getRegionBySlug] frontend slug:', slug, '→ DB slug:', dbSlug);

  try {
    const res = await fetch(`${API_BASE}/get_region.php?slug=${encodeURIComponent(dbSlug)}`);
    const json = await res.json();
    if (!json.success) return null;
    return cleanDeep(json.data);
  } catch (err) {
    console.error("getRegionBySlug error:", err);
    return null;
  }
}

export async function getCouncilLeadership(slug) {
  if (!slug) return [];
  const dbSlug = getDbSlug(slug);
  try {
    const res = await fetch(`${API_BASE}/getCouncilLeadership-state.php?slug=${encodeURIComponent(dbSlug)}`);
    const json = await res.json();
    if (json.success) {
      return cleanDeep(json.data) || [];
    }
    return [];
  } catch (error) {
    console.error('Failed to fetch council leadership:', error);
    return [];
  }
}

export async function fetchRegionEvents(slug) {
  if (!slug) return [];
  const dbSlug = getDbSlug(slug);
  console.log('[fetchRegionEvents] frontend slug:', slug, '→ DB slug:', dbSlug);

  try {
    const res = await fetch(`${API_BASE}/get_region_events.php?slug=${encodeURIComponent(dbSlug)}`);
    const json = await res.json();
    if (!json.success) {
      console.warn('fetchRegionEvents API error:', json.message);
      return [];
    }
    return cleanDeep(json.data) || [];
  } catch (err) {
    console.error("fetchRegionEvents error:", err);
    return [];
  }
}

export async function fetchRegionPublications(slug) {
  if (!slug) return [];
  const dbSlug = getDbSlug(slug);
  try {
    const res = await fetch(`${API_BASE}/get_region_publications.php?slug=${encodeURIComponent(dbSlug)}`);
    const json = await res.json();
    if (!json.success) {
      console.warn('fetchRegionPublications API error:', json.message);
      return [];
    }
    return cleanDeep(json.data) || [];
  } catch (err) {
    console.error("fetchRegionPublications error:", err);
    return [];
  }
}

export async function fetchRegionPressReleases(slug) {
  if (!slug) return [];
  const dbSlug = getDbSlug(slug);
  try {
    const res = await fetch(`${API_BASE}/get_region_press_releases.php?slug=${encodeURIComponent(dbSlug)}`);
    const json = await res.json();
    if (!json.success) {
      console.warn('fetchRegionPressReleases API error:', json.message);
      return [];
    }
    return cleanDeep(json.data) || [];
  } catch (err) {
    console.error("fetchRegionPressReleases error:", err);
    return [];
  }
}

export async function fetchRegionPressCoverage(slug) {
  if (!slug) return [];
  const dbSlug = getDbSlug(slug);
  try {
    const res = await fetch(`${API_BASE}/get_region_press_coverage.php?slug=${encodeURIComponent(dbSlug)}`);
    const json = await res.json();
    if (!json.success) {
      console.warn('fetchRegionPressCoverage API error:', json.message);
      return [];
    }
    return cleanDeep(json.data) || [];
  } catch (err) {
    console.error("fetchRegionPressCoverage error:", err);
    return [];
  }
}